import React from 'react';
import { PRIVATE_MARKDOWN_TABLE_CELL } from './cell';
import { ITableRow, TableColumnAlignment } from '../../parser/table';

interface IPRIVATE_MARKDOWN_TABLE_ROWProps {
  row: ITableRow;
  isHeaderRow: boolean;
  columnAlignments: TableColumnAlignment[];
}

export const PRIVATE_MARKDOWN_TABLE_ROW: React.FunctionComponent<IPRIVATE_MARKDOWN_TABLE_ROWProps> = (props) => {
  const { row } = props;

  return (
    <tr>
      {row.cells.map(cell => <PRIVATE_MARKDOWN_TABLE_CELL
        key={cell.index}
        isHeaderCell={props.isHeaderRow}
        columnAlignment={props.columnAlignments[cell.index]}
        cell={cell}
      />)}
    </tr>
  );
};
